import moment from "moment";
import React, { useEffect, useState } from "react";
import TmsCounterService from "../../../../services/tms-counter.service";
import { Button, Col, notification, Row } from "antd";
import catchErrorFunction from "../../../../utils/tms-catch-error/tms-catch-error";
import { withRouter } from "../../../../utils/tms-with-router/tms-with-router";
import TmsDatepickerRange from "../../../../components/tms-customs/tms-datepicker-range";
import TmsSelect from "../../../../components/tms-customs/tms-select";
import TmsTable from "../../../../components/tms-customs/tms-table";
import TmsDashboardService from "../../../../services/tms-dashboard.service";
import TmsExcelButton from "../../../../components/tms-customs/tms-excel-button";

const ChilderTagReport = ({ router }) => {
  const [bookingDetails, setBookingDetails] = useState([]);
  const [bookingFromDate, setBookingFromDate] = useState(
    moment().format("YYYY-MM-DD")
  );
  const [bookingToDate, setBookingToDate] = useState(
    moment().format("YYYY-MM-DD")
  );
  const [excelLoading, setExcelLoading] = useState(false);

  const [loading, setLoading] = useState();
  const [counter, setCounter] = useState("");
  const [counterList, setCounterList] = useState([]);
  const [tableCurrentPage, setTabelCurrentPage] = useState(1);
  const [tablePageSize, setTabelPageSize] = useState(15);
  const [tableTotalSize, setTabelTotalSize] = useState(0);

  // eslint-disable-next-line no-unused-vars
  const handleTableChange = (pagination, filters, sorter) => {
    setTabelCurrentPage(pagination.current);
    setTabelPageSize(pagination.pageSize);
  };
  const fetchCounterList = async () => {
    try {
      let res = await TmsCounterService.getAllCounter();
      setCounterList(res?.items);
    } catch (e) {
      notification.error({ message: e?.message });
    }
  };

  useEffect(() => {
    fetchCounterList();
  }, []);

  useEffect(() => {
    fetchBookingDetails();
  }, [tableCurrentPage, tablePageSize]);

  const fetchBookingDetails = async () => {
    setLoading(true);
    try {
      const data = await TmsDashboardService.getReportsByType(
        bookingFromDate,
        bookingToDate,
        "children_pass",
        Number(tableCurrentPage),
        Number(tablePageSize),
        counter
      );
      setTabelTotalSize(data?.meta?.total);
      setBookingDetails(
        data?.data?.map((item) => {
          return { key: item?.id, ...item };
        })
      );
    } catch (error) {
      catchErrorFunction(
        error,
        "Token Expired, redirecting to login page in 5 seconds",
        router
      );
    }
    setLoading(false);
  };
  const handleExcelExport = async () => {
    setExcelLoading(true);
    try {
      let data = await TmsDashboardService.getReportsByTypeDownload(
        bookingFromDate,
        bookingToDate,
        "children_pass",
        Number(tableCurrentPage),
        Number(tablePageSize),
        counter
      );

      // Create blob and download
      const blob = new Blob([data], {
        type: "applicationa/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = "children-pass-report.xlsx";

      // Trigger download
      document.body.appendChild(link);
      link.click();

      // Cleanup
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
      setExcelLoading(false);
    } catch (error) {
      catchErrorFunction(error, "Token expired!! Please login again.", router);
      setExcelLoading(false);
    }
  };
  const columns = [
    {
      title: "ID",
      key: "id",
      dataIndex: "id",
    },

    {
      title: "Child tag ID",
      key: "childrenTagId",
      dataIndex: "childrenTagId",
    },

    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      render: (text) => {
        return text ?? "-";
      },
    },

    {
      title: "Father Name",
      dataIndex: "fatherName",
      key: "fatherName",
      render: (text) => {
        return text ?? "-";
      },
    },
    {
      title: "Mobile",
      dataIndex: "mobile",
      key: "mobile",
      render: (text) => {
        return text ?? "-";
      },
    },
    {
      title: "Gender",
      dataIndex: "gender",
      key: "gender",
      render: (text) => {
        return text ?? "-";
      },
    },
    {
      title: "Address",
      dataIndex: "address",
      key: "address",
      render: (text) => {
        return text ?? "-";
      },
    },
    {
      title: "Created At",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (text) => {
        return moment(text).format("DD-MM-YYYY HH:mm:ss");
      },
    },
  ];
  return (
    <div>
      <Row gutter={[20, 20]}>
        <TmsDatepickerRange
          className={"m-0"}
          label="Time period"
          to={bookingToDate}
          from={bookingFromDate}
          setFrom={setBookingFromDate}
          setTo={setBookingToDate}
        />{" "}
        <TmsSelect
          type="col"
          span={3}
          label="POS"
          setValue={setCounter}
          value={counter}
          data={counterList}
        />{" "}
        <TmsExcelButton
          span={24}
          loading={excelLoading}
          handleExcelExport={handleExcelExport}
          top={true}
        />
        <Col>
          <Row justify="start" style={{ marginBottom: "5px" }}>
            Update
          </Row>
          <Button type="primary" onClick={fetchBookingDetails}>
            Fetch
          </Button>
        </Col>
      </Row>
      <br />
      <Row>
        <TmsTable
          columns={columns}
          dataSource={bookingDetails}
          loading={loading}
          handleTableChange={handleTableChange}
          pagination={{
            total: tableTotalSize,
            current: tableCurrentPage,
            pageSize: tablePageSize,
          }}
        ></TmsTable>
      </Row>
    </div>
  );
};

export default withRouter(ChilderTagReport);
